import { onCleanup, onMount } from "solid-js";

declare namespace createFocusOnMount {
  type Options = {
    delay?: number;
  };
}

function createFocusOnMount({ delay = 0 }: createFocusOnMount.Options = {}) {
  let ref: HTMLElement;

  onMount(() => {
    if (!ref) return;

    const timeout = setTimeout(() => {
      createFocusOnMount.selectInput(ref)?.focus();
    }, delay);

    onCleanup(() => {
      clearTimeout(timeout);
    });
  });

  return (element: typeof ref) => {
    ref = element;
  };
}

createFocusOnMount.selectInput = (element: HTMLElement) =>
  element instanceof HTMLInputElement
    ? element
    : element?.querySelector("input") || element?.querySelector("textarea");

export default createFocusOnMount;
